<template>
  <span
    :style="{ 
      paddingTop: '5px',
      paddingBottom: '5px',
      display: 'block'
    }"
  >
    <my-icon-card
      :faIcon="!isLate && isComplete ? 'check' : isLate ? 'times' : 'cogs'"
      :data="processedKeys"
      :displayKeys="Object.keys(processedKeys)"
      :color="!isLate && isComplete ? '#1FDD00' : isLate ? '#E74725' : 'tan'"
      :rows="2"
      :cardWidth="width || '96%'"
      :altRows="{ 'Job description': 100 }"
      :hideLabels="true"
      :forceShowLabels="['Job description']"
      :applyStyles="(key, index) => calculateCardStyles(key, index)"
      :menu="{
        edit: {
          action: editInvoiceClick,
          icon: 'pencil-alt',
          color: '#7CFF67',
        },
        print: {
          action: printItemClick,
          icon: 'print',
          color: '#4ABEFF',
        },
        trash: {
          action: deleteInvoiceClick,
          icon: 'trash',
          color: 'rgb(255, 127, 127)',
        },
      }"
    >
      <template v-slot:funds>
        <ul class='card-slot-funds'>
          <li class="dollar-sign"><p>$</p></li>
          <li class="amount"><p>{{ fMon(info.owe) }}</p></li>
          <li class="amount"><p>{{ fMon(info.paid) }}</p></li>
          <li class="amount"><p>{{ fMon(balance) }}</p></li>
        </ul>
      </template>
    </my-icon-card>

  </span>
</template>

<script>
import { calc, fMon } from "../utils/money";
import logoUrl from "../assets/logo.png";
import { localParse, dateGreaterThan } from "../utils/date";
import getStatus from "../constants/status";
import TextComponent from "./TextComponent";
import router from "../router";
import MyIconCard from "@/myComponents/MyIconCard.vue";
export default {
  components: { MyIconCard },
  props: ["info", "width"],
  data: () => ({
    fMon,
    getStatus,
    logoUrl,
    active: false,
  }),
  name: "invoice",
  methods: {
    calculateCardStyles(params) {
      const { key, sticky } = params;
      let styles = {
        marginTop: "4px",
        marginBottom: "4px",
      };
      if (["invoice", "status", "number", "payType"].includes(key)) {
        styles.textAlign = "right";
      }
      if (key === "business") styles.fontWeight = "bold";
      if (["dates", "payType"].includes(key)) {
        styles = {
          ...styles,
          marginTop: "20px",
          color: sticky ? "#000" : "#b9b9b9",
        };
      }
      if (key === "funds") {
        styles.height = '5px'
        styles.width = '100%'
        styles.padding = 0
        styles.marginTop = '-10px'
      }
      return styles;
    },
    toggleActive() {
      this.active = !this.active;
    },
    editInvoiceClick() {
      router.push("/newinvoice/edit/" + this.info.invoice);
    },
    deleteInvoiceClick() {
      this.$store.commit("setModal", {
        component: TextComponent,
        mounted: true,
        header: "Confirm delete",
        props: {
          text:
            "Are you sure you want to delete invoice #" +
            this.info.invoice +
            "?",
        },
        goodClick: () => {
          this.$store.dispatch("deleteInvoice", this.info.invoice);
        },
      });
    },
    printItemClick() {
      const i = this.info;
      const b = this.$store.getters.user;
      const mywindow = window.open("", "PRINT", "height=800,width=900");
      mywindow.document.write(`
        <html>
          <head>
            <title> ${i.invoice} </title>
          </head>
          <body>
            <ul>
              <li class='logo'>
                ${b["company name"]}
              </li>
              <li class='header'>
                <span>${b["number"]}</span>
                <span>${b["site"]}</span>
              </li>
              <li class='header'>
                <span>${b["address"]}</span>
                <span>${b["email"]}</span>
              </li>
              <li class='line thick' />
              <li>
                <span>Business</span>
                <p>${i.business || "<br />"}</p>
              </li>
              <li class='right'>
                <span>Order status</span>
                <p>${getStatus(i.status)}</p>
              </li>
               <li class='right'>
                <span>Invoice number</span>
                <p>${i.invoice}</p>
              </li>
              <li class='line' />
              <li>
                <span>Customer name</span>
                <p>${i.firstname} ${i.lastname} ${
        !i.firstname && !i.lastname ? "<br />" : ''
      }</p>
              </li>
              <li class='right'>
                <span>Phone number</span>
                <p>${i.number || "<br />"}</p> 
              </li>
              <li class='right'>
                <span>Email address</span>
                <p>${i.email}</p> 
              </li>
              <li class='descr'>
                <span>Description</span>
                <p> ${i.descr} </p>
              </li>
               <li class='dates'>
               <span>Start date / Due date</span>
                ${i.orderdate} -> ${i.orderdue}
              </li>
              <li class='funds'>
                <div>
                  <span>Payment type</span>
                  ${fMon(i.payType)} 
                </div>
                <div>
                  <span>Total</span>
                  ${fMon(i.owe)} 
                </div>
                <div>
                  <span>Paid</span>
                  ${fMon(i.paid)} 
                </div>
                <div>
                  <span>Remaining</span>
                  ${fMon(this.balance)}
                </div>
              </li>
              <li class='line' />
              <li class='long-disclaimer'>${b["disclaimer"]}</li>
              <li class='sign-field'>
                <span>Project agreement</span>
                <p>customer signature</p>
              </li>
              <li class='sign-field'>
                <span>Project complete</span>
                <p>customer signature</p>
              </li>
              <li class='sign-off'>${b["signOff"]}</li>
            </ul>
          </body>
            <style>
              ul {
                list-style-type: none;
                margin: 0;
                padding: 0;
                display: flex;
                flex-wrap: wrap;
              }
              li {
                width: 28%;
                margin: 0 auto;
                font-size: 1rem;
                font-family: sans-serif;
              }
              li.logo {
                font-weight: bold;
                font-size: 1rem;
                padding-top: 18px;
              }
              li span {
                margin-top: 8px;
                width: 100%;
                margin-bottom: 4px;
                display: block;
                color: #555;
                font-size: .8rem;
              }
              li.line{
                padding: 0;
                height: 0px;
                border-bottom: 2px solid #d9d9d9;
                width: 90%;
                margin: 16px auto 10px auto;
              }
              li.line.thick {
                width: 98%;
                border-bottom: 10px solid #d9d9d9;
              }
              li p {
                margin: 0;
                padding: 0;
              }
              li.right {
                text-align: right;
              }
              li.dates {
                padding-top: 6px;
              }
              li.descr {
                border: 2px dotted gray;
                width: 95%;
                padding: 5px 10px 10px 10px;
                border-radius: 5px;
                margin: 10px auto 20px auto;
                font-size: .9rem;
              }
              .descr p {
                white-space: pre-wrap;
                line-height: 20px;
              }
              li.descr span {
                margin-bottom: 8px;
                font-size: .8rem;
              }
              .action-bar{
                display: none;
              }
              li.sign-field{
                width: 48%;
              }
              .sign-field p {
                border-bottom: 2px solid gray;
                padding-bottom: 10px;
                font-size: .85rem;
              }
              .funds {
                width: auto;
                display: flex;
                justify-content: flex-end;
                width: 65%;
                margin: 0 auto;
                text-align: right;
                margin-bottom: 10px;
              }
              .funds span{
                background-color: gray;
                color: #fff;
                padding: 2px 5px;
                border-radius: 4px;
                font-weight: bold;
              }
              .funds div {
                margin-left: 30px;
              }
              li.header{
                width: 33%;
              }
              li.header span{
                font-size: .88rem;
                text-align: right;
              }
              .long-disclaimer, .sign-off {
                width: 100%;
                margin: 0 auto;
                font-size: .68rem;
                margin-top: 10px;
                margin-bottom: 10px;
                color: #b5b5b5;
                font-style: italic;
              }
            </style>
        </html>
      `);

      mywindow.document.close();
      mywindow.focus();

      mywindow.print();
      mywindow.close();

      return true;
    },
  },
  computed: {
    processedKeys() {
      const {
        invoice,
        business,
        firstname,
        lastname,
        status,
        email,
        number,
        descr,
        orderdate,
        orderdue,
        payType,
      } = this.info;
      return {
        business,
        invoice,
        name: firstname + " " + lastname,
        status: getStatus(status),
        sep: "sep",
        email,
        number,
        "Job description": descr,
        dates: `${orderdate} -> ${orderdue}`,
        payType,
        funds: "my-card-slot",
      };
    },
    isLate() {
      if (this.info.orderdue === "") return false;
      const today = localParse();
      const late = dateGreaterThan(today, this.info.orderdue);
      if (this.isComplete) return false;
      return late;
    },
    isComplete() {
      return (
        this.balance === 0 && getStatus(this.info.status) === "Order Complete"
      );
    },
    balance() {
      return calc(this.info.owe, this.info.paid, "sub");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/colors.scss";
@import "../styles/vars.scss";
$sideWidth: 80px;
$sideWidthClosed: 30px;

.card-slot-funds {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-right: -10px;
  & li {
    padding: 9px 25px;
    margin: 0;
    background-color: lightblue;
    background-color: $lightBlue;
    color: #fff;
    font-weight: bold;
    &:first-child{
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $darkBlue;
      border: 4px solid $darkBlue;
      height: 39px;
      width: 42px;
      margin-right: -23px;
      z-index: 3;
      font-size: 3rem;
      padding: 0;
      p {
        font-size: 1.4rem;
      }
    }
    &:nth-child(2) {
      padding-left: 40px;
      z-index: 2;
    }
    &:last-child {
      border-radius: 0 0 5px 0;
    }
    p {
      padding: 0;
      margin: 0;
    }
  }
}

.invoice {
  position: relative;
  width: 96%;
  margin: 20px auto 40px auto;
  background-color: #fff;
  color: rgb(88, 88, 88);
  border-radius: 5px;
  .action-bar {
    position: absolute;
    width: 0;
    background-color: #fff;
    overflow: hidden;
    top: -5px;
    right: -10px;
    transition: all 0.3s;
    & > button {
      margin-right: 10px;
      height: 60px;
      font-size: 1.1rem;
      width: 60px;
      border-radius: 50%;
      border: 6px solid $lightBlue;
      background-color: $darkBlue;
      &:nth-child(2) {
        border: 6px solid rgb(255, 127, 127);
        background-color: $red;
      }
      &:nth-child(3) {
        border: 6px solid $lightGreen;
        background-color: $green;
      }
      &:hover {
        border: 6px solid $lightGray;
        background-color: $darkGray;
      }
    }
  }
  .date {
    bottom: -9px;
    position: relative;
    @media screen and (max-width: $med-break) {
      bottom: 0;
    }
  }
  & > div {
    width: $sideWidth;
    background-color: $green;
    border-radius: 5px 0 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-size: 1.7rem;
      font-weight: 900;
      color: #fff;
      opacity: 0.5;
    }
    @media screen and (max-width: $med-break) {
      width: $sideWidthClosed;
      & p {
        display: none;
      }
    }
  }
  & > div {
    background-color: tan;
  }
  &.late-invoice > div {
    background-color: $red;
  }
  &.is-complete > div {
    background-color: $green;
  }
  ul {
    margin: 0;
    list-style-type: none;
    padding: 0;
    width: calc(100% - #{$sideWidth});
    margin: 0 auto;
    position: relative;
    @media screen and (max-width: $med-break) {
      width: calc(100% - #{$sideWidthClosed});
    }
    li {
      display: flex;
      justify-content: space-between;
      margin: 15px 10px;
      &.sep {
        height: 1px;
        padding: 0;
        background-color: $lightGray;
        height: 1px;
        margin-bottom: 18px;
      }
      &.descr {
        background-color: #f9f9f9;
        flex-direction: column;
        border-radius: 4px;
        margin-bottom: 15px;
        line-height: 1.5rem;
        p {
          padding: 10px;
          margin: 0;
          white-space: pre-wrap;
        }
        .strong {
          padding-bottom: 0;
          color: $darkGray;
        }
      }
      &.funds {
        justify-content: flex-end;
        color: #fff;
        font-weight: bold;
        width: 100%;
        position: relative;
        padding: 0;
        margin: 0;
        height: 15px;
        top: -20px;
        & .dollar-sign {
          position: relative;
          bottom: -8px;
          right: -12px;
          height: 40px;
          width: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $darkBlue;
          border: 4px solid $darkBlue;
          background-color: $lightBlue;
          font-weight: bold;
          p {
            font-size: 1.6rem;
          }
        }
        .amount {
          p {
            background-color: $lightBlue;
            padding: 9px 10px 9px 60px;
          }
          &:nth-child(4) {
            p {
              border-radius: 0 3px 3px 0;
            }
          }
          &:nth-child(2) {
            p {
              padding-left: 30px;
            }
          }
        }
        bottom: 0;
        right: 0;
        @media screen and (max-width: $med-break) {
          top: 0;
          width: 99%;
          height: auto;
          .amount p {
            padding: 10px;
            margin: 0 0 5px 0;
            background: none;
            color: #000;
          }
          .dollar-sign {
            display: none;
          }
        }
      }
      .light {
        color: $darkGray;
        font-size: 0.9rem;
      }
    }
  }
  &:hover,
  &.active {
    box-shadow: 0 0 13px rgba(0, 0, 0, 0.2);
    & .action-bar {
      width: 210px;
    }
  }
  &.active {
    color: #000;
    background-color: rgb(239, 255, 255);
    box-shadow: 0 0 0 2px $lightBlue;
    & .action-bar {
      background-color: rgb(239, 255, 255);
    }
    & .descr {
      background-color: rgb(231, 255, 255);
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    }
    &:hover {
      & .action-bar {
        width: 0px;
      }
    }
  }
}
</style>
